module.exports = __webpack_public_path__ + "static/media/basketball_sell.78b5a0fd.png";